import { useEffect, useState } from "react";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../common/components/Loader/Loader";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { useBookingListState, useBookingStore } from "./store/_bookingStore";
import { BookingService } from "./store/_requests";
import { BookingDetails } from "./components/BookingDetails";
import { BookingForm } from "./components/BookingForm";
import { API_URLs } from "../../../utilities/API_URLs";
import { StatusTag } from "../../../common/components/Status/StatusTag";
import { BookingDelayStatusConstant, BookingStateConstant } from "./core/_constant.booking";
import { Tag } from "antd";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { Filters } from "../components/Filters";
import style from "./style.module.scss"

export const Booking = () => {

  const {
    setBookingList,
    bookingList,
    actioned,
    totalItems,
    setActioned,
  } = useBookingStore();
  const { pageState, setPageState, resetPageState } =
    useBookingListState();

  const [drawerMode, setDrawerMode] = useState<"add" | "details" | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "N° Booking",
      dataIndex: "reference",
      searchType: "text",
      show: true,
    },
    {
      key: "blNumber",
      title: "N° BL",
      dataIndex: "blNumber",
      searchType: "text",
      show: true,
    },
    {
      key: "containerIdentifiers",
      title: "Identifiant conteneur",
      dataIndex: "containerIdentifiers",
      show: true,
      render: (state: any) => (
        state.map((item: any) => (
          <div className="mb-1"><Tag>{item}</Tag></div>
        ))
      )
    },
    {
      key: "gateOutReferences",
      title: "Ref gate out",
      dataIndex: "gateOutReferences",
      show: true,
      render: (state: any) => (
        state.map((item: any) => (
          <div className="mb-1">
            {item ? <Tag>{item}</Tag> : <>-</>}
          </div>
        ))
      )
    },
    {
      key: "bookingSource",
      title: "Source",
      dataIndex: "bookingSource",
      show: true,
      render: (source: any) => {
        return (<span>{source?.name ?? "-" }</span>)
      }
    },
    {
      key: "customer",
      title: "Transitaire",
      dataIndex: "customer",
      nestedKey: "customer",
      show: true,
      render: (customer: any) => (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <span>{customer?.name ?? "-"}</span>
        </div>
      ),
    },
    {
      key: "finalCustomer",
      title: "Client",
      dataIndex: "finalCustomer",
      nestedKey: "finalCustomer",
      show: true,
      render: (finalCustomer: any) => (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <span>{finalCustomer?.name ?? "-"}</span>
        </div>
      ),
    },
    {
      key: "latestGateOutDate",
      title: "Gate-out au plus tard",
      dataIndex: "latestGateOutDate",
      show: true,
    },
    {
      key: "badDelayStatus",
      title: "Jours restants",
      dataIndex: "badDelayStatus",
      show: true,
      render: (badDelayStatus: any) => (
        <span>{badDelayStatus.remainingDays}</span>
      )
    },
    {
      key: "bookingState",
      title: "Statut",
      dataIndex: "bookingState",
      searchKey: "bookingState",
      show: true,
      render: (bookingState: any) => (
        <StatusTag
          value={bookingState?.id}
          options={BookingStateConstant.OPTIONS}
        />
      ),
    },
    {
      key: "badDelayStatus",
      title: "Statut Délai",
      dataIndex: "badDelayStatus",
      show: true,
      render: (state: any) => {
        return (
          <StatusTag
            value={state?.status?.id}
            options={BookingDelayStatusConstant.OPTIONS}
          />
        );
      },
    },
    {
      key: "createdAt",
      title: "Date de création",
      dataIndex: "createdAt",
      // isCanSort: true,
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllBooking(pageState);
  }, [pageState]);

  const onActionClick = async (item: any, action: ActionsKey) => {
    try {
      setIsLoading(true);
  
      const res = await BookingService.getBookingById(item?.id);
  
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
  
        setDrawerMode("details");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleOnAdd = () => {
    setActioned(null);
    setDrawerMode("add");
  };
  
  const handleCloseDrawer = () => {
    setDrawerMode(null);
    setActioned(null);
  };

  const fetchAllBooking = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await BookingService.getBookingList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setBookingList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <div className={`${style.booking__title}`}>
      <TitleHeader
        title="Réservations (Booking)"
      />
      <div>
      <CustomButton
        className="d-flex align-items-center justify-content-center p-2 mt-4"
        style={{
          width: "200px",
          height: "40px"
        }}
        onClick={() => {
          handleOnAdd()
        }}
      >
        <div>
          <span className="fw-semibold fs-6">Nouveau</span>
        </div>
      </CustomButton>
      </div>
      
    </div>
    <Filters
      uri={API_URLs.booking.badDelayStatesForSelect}
      filterKey="bookingState"
      params={pageState}
      initialParams={{
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      }}
      onChange={handleSetParams}
    />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={bookingList}
            params={pageState}
            onAction={onActionClick}
            isCanShow={() => true}
            onSearch={handleSetParams}
            //onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
          />
        </div>
      </div>

      {/* Drawer section  */}
      <CustomDrawer
        isOpen={drawerMode !== null}
        onClose={handleCloseDrawer}
        title={drawerMode === "details" ? "Détails" : "Ajouter un booking"}
        width="75%"
      >
        {drawerMode === "details" && actioned?.data ? (
          <BookingDetails value={actioned.data} />
        ) : drawerMode === "add" ? (
          <BookingForm
            onSuccess={() => {
              setDrawerMode(null);
              fetchAllBooking(pageState);
            }}
          />
        ) : null}
      </CustomDrawer>
    </div>
  );
};
